/**
 * This file is automatically generated by build-environment-file.mjs
 * Do not edit this file directly
 * To insert a new variable, add it to the .env file and npm run setup.
 */

export const environment = {
  PRODUCTION: false,
  STAGE: 'dev',
  API_URL: 'https://api.core.connect.eu.dev.kyloe.plus',
  COGNITO_CLIENT_ID: '7lpr8s1ta575993pfiilmkr5gl',
  COGNITO_AUTH_DOMAIN: 'https://auth.core.connect.eu.dev.kyloe.plus',
  COGNITO_REDIRECT_URI: 'https://core.connect.eu.dev.kyloe.plus/login/callback',
  COGNITO_SCOPES: 'openid email profile',
};
